/* This file was created automatically, don't change it manually. */

import React, { forwardRef } from 'react';

import { ColorlessIconProps } from '../../types';
import { SVGContainer } from '../../SVGContainer';

const IconShow8 = forwardRef<SVGSVGElement, ColorlessIconProps>(function IconShow8(props, ref) {
    return (
        <SVGContainer {...props} viewBox="0 0 8 8" ref={ref}>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M1.869 2.082a4.184 4.184 0 0 1 5.796 1.585v.666a4.187 4.187 0 0 1-7.333 0v-.666a4.182 4.182 0 0 1 1.537-1.585Zm2.13.085A1.167 1.167 0 1 0 3.997 4.5 1.167 1.167 0 0 0 4 2.167h-.001Zm-1.678.425a1.833 1.833 0 1 0 3.354 0A3.53 3.53 0 0 1 7 3.846L7.082 4l-.083.154a3.52 3.52 0 0 1-6 0L.915 4 1 3.846A3.516 3.516 0 0 1 2.32 2.592Z"
                fill="currentColor"
            />
        </SVGContainer>
    );
});

const IconShow12 = forwardRef<SVGSVGElement, ColorlessIconProps>(function IconShow12(props, ref) {
    return (
        <SVGContainer {...props} viewBox="0 0 12 12" ref={ref}>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M2.805 3.123a6.275 6.275 0 0 1 6.39 0A6.274 6.274 0 0 1 11.5 5.5v1a6.281 6.281 0 0 1-11 0v-1a6.274 6.274 0 0 1 2.305-2.377ZM6 3.25a1.75 1.75 0 1 0-.003 3.5 1.75 1.75 0 0 0 .004-3.5H6Zm-2.516.638a2.75 2.75 0 1 0 5.032 0A5.274 5.274 0 0 1 10.5 5.769l.125.23-.125.232a5.28 5.28 0 0 1-9 0L1.375 6l.125-.231a5.274 5.274 0 0 1 1.984-1.881Z"
                fill="currentColor"
            />
        </SVGContainer>
    );
});

const IconShow16 = forwardRef<SVGSVGElement, ColorlessIconProps>(function IconShow16(props, ref) {
    return (
        <SVGContainer {...props} viewBox="0 0 16 16" ref={ref}>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M3.742 4.164a8.367 8.367 0 0 1 8.519 0 8.365 8.365 0 0 1 3.074 3.17v1.333a8.375 8.375 0 0 1-11.592 3.168A8.375 8.375 0 0 1 .668 8.667V7.333a8.365 8.365 0 0 1 3.074-3.169Zm4.26.17A2.333 2.333 0 1 0 7.997 9a2.333 2.333 0 0 0 .005-4.667h-.002Zm-3.355.85a3.667 3.667 0 1 0 6.709 0A7.04 7.04 0 0 1 14 7.692l.167.308-.167.308a7.04 7.04 0 0 1-12 0L1.835 8 2 7.692a7.032 7.032 0 0 1 2.646-2.508Z"
                fill="currentColor"
            />
        </SVGContainer>
    );
});

const IconShow24 = forwardRef<SVGSVGElement, ColorlessIconProps>(function IconShow24(props, ref) {
    return (
        <SVGContainer {...props} viewBox="0 0 24 24" ref={ref}>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M5.61 6.246A12.55 12.55 0 0 1 12 4.5 12.55 12.55 0 0 1 23 11v2a12.562 12.562 0 0 1-17.388 4.753A12.562 12.562 0 0 1 1 13v-2a12.548 12.548 0 0 1 4.61-4.754ZM12 6.5a3.5 3.5 0 1 0-.005 7 3.5 3.5 0 0 0 .008-7H12ZM6.968 7.776a5.5 5.5 0 1 0 10.063 0A10.55 10.55 0 0 1 21 11.538l.251.462-.25.461a10.562 10.562 0 0 1-14.37 3.57A10.561 10.561 0 0 1 3 12.46L2.75 12l.25-.462a10.55 10.55 0 0 1 3.968-3.762Z"
                fill="currentColor"
            />
        </SVGContainer>
    );
});

export const IconShow = forwardRef<SVGSVGElement, ColorlessIconProps>(function IconShow(props, ref) {
    const { size = '16', role = 'supplementary' } = props;

    const iconProps = {
        ...props,
        size,
        ref,
        role,
        colorless: true,
    } as const;

    switch (size) {
        case '8':
            return <IconShow8 {...iconProps} />;
        case '12':
            return <IconShow12 {...iconProps} />;
        case '16':
            return <IconShow16 {...iconProps} />;
        case '24':
            return <IconShow24 {...iconProps} />;
        default:
            return <IconShow24 {...iconProps} />;
    }
});
